import {
  GET_MEMBER_DEFINITIONS_SUCCESS,
  ADD_MEMBER_DEFINITION_SUCCESS,
  UPDATE_MEMBER_DEFINITION_SUCCESS,
  DELETE_MEMBER_DEFINITION_SUCCESS,
  MEMBER_DEFINITION_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  memberDefinitions: [],
  error: {},
}

const MemberDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_MEMBER_DEFINITIONS_SUCCESS:
      return {
        ...state,
        memberDefinitions: action.payload,
      }

    case ADD_MEMBER_DEFINITION_SUCCESS:
      return {
        ...state,
        memberDefinitions: [...state.memberDefinitions, action.payload],
      }

    case UPDATE_MEMBER_DEFINITION_SUCCESS:
      return {
        ...state,
        memberDefinitions: state.memberDefinitions.map(memberDefinition =>
          memberDefinition.guid.toString() === action.payload.guid.toString()
            ? { memberDefinition, ...action.payload }
            : memberDefinition
        ),
      }

    case DELETE_MEMBER_DEFINITION_SUCCESS:
      return {
        ...state,
        memberDefinitions: state.memberDefinitions.filter(
          memberDefinition => memberDefinition.guid.toString() !== action.payload.guid.toString()
        ),
      }

    case MEMBER_DEFINITION_API_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:

      return state

  }
}

export default MemberDefinition